export const setTotalTasksCount = (state, totalTasks) => {
  state.totalTasksCount = totalTasks;
};

export const setIncompleteTasksCount = (state, incompleteTasks) => {
  state.incompleteTasksCount = incompleteTasks;
};

export const setOpenTasksCount = (state, openTasks) => {
  state.openTasksCount = openTasks;
};
